module.exports = __webpack_public_path__ + "media/newstyle/images/icon-chevron_left-orange-c43d1be27140df761da79ec85b512936.svg";